import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/GeolocationGuide.css';

function GeolocationGuide() {
  return (
    <div className="geolocation-guide">
      <h1>Guida per reimpostare i permessi di geolocalizzazione</h1>
      
      <div className="guide-content">
        <p className="warning">
          Purtroppo se hai negato i permessi non è possibile reimpostarli da qui. 
          Devi seguire questi passaggi nel tuo browser:
        </p>

        <div className="browser-section">
          <h2>Chrome (Desktop e Mobile)</h2>
          <ol>
            <li>Clicca sull'icona del lucchetto/globale nella barra degli indirizzi</li>
            <li>Seleziona "Impostazioni sito" o "Site settings"</li>
            <li>Trova "Posizione" o "Location"</li>
            <li>Cambia l'impostazione da "Blocca" a "Chiedi"</li>
            <li>Ricarica la pagina</li>
          </ol>
        </div>

        <div className="browser-section">
          <h2>Safari (iOS)</h2>
          <ol>
            <li>Apri le Impostazioni del tuo iPhone/iPad</li>
            <li>Scorri fino a trovare Safari</li>
            <li>Seleziona "Impostazioni per i siti web"</li>
            <li>Seleziona "Posizione"</li>
            <li>Trova il nostro sito e imposta su "Chiedi"</li>
            <li>Ritorna al browser e ricarica la pagina</li>
          </ol>
        </div>

        <div className="browser-section">
          <h2>Firefox</h2>
          <ol>
            <li>Clicca sull'icona del lucchetto/globale nella barra degli indirizzi</li>
            <li>Seleziona "Impostazioni"</li>
            <li>Trova "Posizione"</li>
            <li>Cambia l'impostazione da "Blocca" a "Chiedi"</li>
            <li>Ricarica la pagina</li>
          </ol>
        </div>
      </div>

      <div className="back-link">
        <Link to="/">← Torna alla mappa</Link>
      </div>
    </div>
  );
}

export default GeolocationGuide; 